<div class="flex flex-wrap flex-row image-container w-full h-auto">
    <div class="w-full flex justify-end p-1 overlay-button">

        @if (!isAdClosed) {
        <button
            class="flex justify-center items-center bg-[#f1e9eb] text-blue-700 border border-white-700 rounded w-[2rem] h-[2rem]"
            (click)="onClickEvent($event , 'on_ad_closed')">X</button>
        }
    </div>
    <div class="w-full flex justify-end p-1 overlay-button overlay-skip-button">
        <button
            class="flex justify-center items-center bg-[#f1e9eb] text-blue-700 border border-white-700 rounded lg:w-[10rem] md:[10rem] sm:w-[17%] w-[30%] h-[2rem] "
            [class]="{'opacity-50' : count() < 5}" [disabled]="count() < 5"
            (click)="onClickEvent($event , 'on_ad_skip')">{{(5 - count() > 0 ? 5 - count() :
            0).toFixed()}} Skip</button>
    </div>
    <div class="w-full h-full">
        @if (isAdClosed) {
        <div class="skipped-cover" (click)="onClickEvent($event , 'on_ad_click')"></div>
        }
        <iframe [src]="getSafeUrl(adData.ads[index].creative.assetUrl)" frameborder="0" (click)="onClickEvent($event , 'on_ad_click')"></iframe>
       
    </div>

    <button hidden (click)="pauseImg()" id="pause-button"></button>
    <button hidden (click)="playImg()" id="play-button"></button>
</div>